$(document).ready(function (e) {

    $('.add-xml-mapping').on('click', function(e){
        let table_id = $('#integration-crm-table').val(),
            $container = $('.xml-mappings-holder');
        $.ajax({
            type : "GET",
            url : '/settings/xml_builder/mapping',
            data : {
                table_id,
                is_section : 0
            },
            success: function(mapping){
                $('.xml-mappings-holder').append(mapping);
                reCalculateXMLMappingIndex($container);
                $('.sortable-xml-mapping').sortable({
                    cursor: 'grab',
                    connectWith: ".sortable-xml-mapping",
                    stop: function( ) {
                        reCalculateXMLMappingIndex($container);
                    }
                });
            }
        });
    });

    $(document).on('click', '.add-section-xml-mapping', function(e){
        let table_id = $(this).attr('data-table-id'),
            $container = $(this).parents('.section-xml-mappings-container').find('.xml-mappings-section-holder');
        $.ajax({
            type : "GET",
            url : '/settings/xml_builder/mapping',
            data : {
                table_id,
                is_section: 1
            },
            success: function(mapping){
                $container.append(mapping);
                reCalculateXMLMappingIndex($container);
                $('.sortable-xml-mapping').sortable({
                    cursor: 'grab',
                    connectWith: ".sortable-xml-mapping",
                    stop: function( ) {
                        reCalculateXMLMappingIndex($container);
                    }
                });
            }
        });
    });

    $(document).on('click', '.remove-xml-mapping', function(e){
        $(this).parents('.xml-mapping').remove();
        let $container = $('.xml-mappings-holder');
        reCalculateXMLMappingIndex($container);
    });

    $(document).on('click', '.remove-section-xml-mapping', function(e){
        let $container = $(this).parents('.xml-mappings-section-holder');
        $(this).parents('.xml-mapping').remove();
        reCalculateXMLMappingIndex($container);
    });

    $('.xml-builder-form').one('submit', handleXMLBuilderFormChange);

    function handleXMLBuilderFormChange(e) {
        e.preventDefault();

        let errors = false,
            $mappings = $('.xml-mappings-holder').find('.xml-mapping'),
            $section_holders = $('.section-xml-mappings-container'),
            xml_mappings = [],
            sections_enabled = [],
            section_mappings = {};

        if(!$mappings.length){
            errors = true;
            alert('Please add mappings');
        }else{
            $mappings.each(function (index, $mapping) {
                let comment = $($mapping).find('.xml-comment').val(),
                    type = $($mapping).find('.xml-type').val(),
                    tag_name = $($mapping).find('.xml-tag-name').val(),
                    value = $($mapping).find('.xml-value').val(),
                    xml_field = $($mapping).find('.xml-fields').val(),
                    xml_section = $($mapping).find('.xml-sections').val(),
                    primary_column = $($mapping).find('.related-xml-fields').val();

                if(type === 'XML tag with database field'){
                    value = xml_field;
                }

                if(type === 'XML tag with section'){
                    value = xml_section;
                }

                xml_mappings.push({
                    comment : comment,
                    type: type,
                    tag_name: tag_name,
                    value: value,
                    primary_column : primary_column
                });
            });
        }

        $section_holders.each(function (index, $xml_section) {
            $xml_section = $($xml_section);
            let id = $xml_section.attr('data-section-id'),
                $mappings = $xml_section.find('.xml-mapping'),
                enabled = $xml_section.find('.xml-section-visibility').is(':checked');

            if(enabled){
                sections_enabled.push(id);

                if(section_mappings[id] === undefined){
                    section_mappings[id] = [];
                }

                if(!$mappings.length){
                    errors = true;
                    alert('Please add section mappings');
                }else{
                    $mappings.each(function (index, $mapping) {
                        let comment = $($mapping).find('.xml-comment').val(),
                            type = $($mapping).find('.xml-type').val(),
                            tag_name = $($mapping).find('.xml-tag-name').val(),
                            value = $($mapping).find('.xml-value').val(),
                            xml_field = $($mapping).find('.xml-fields').val(),
                            xml_section = $($mapping).find('.xml-sections').val(),
                            primary_column = $($mapping).find('.related-xml-fields').val();

                        if(type === 'XML tag with database field'){
                            value = xml_field;
                        }

                        if(type === 'XML tag with section'){
                            value = xml_section;
                        }

                        section_mappings[id].push({
                            comment : comment,
                            type: type,
                            tag_name: tag_name,
                            value: value,
                            primary_column : primary_column
                        });
                    });
                }
            }
        });

        if(!errors){
            $('input[name="xml_mappings"]').val(JSON.stringify(xml_mappings));
            $('input[name="section_xml_mappings"]').val(JSON.stringify(section_mappings));
            $('input[name="sections_enabled"]').val(JSON.stringify(sections_enabled));
            $(this).submit();
        }else{
            $('.xml-builder-form').one('submit', handleXMLBuilderFormChange);
        }
    }

    $('#export-table').on('change', function(e){
        let id = $(this).val();

        if(id.length){
            $.ajax({
                type : 'GET',
                url : '/settings/xml_builder/modal_data',
                data : {
                    table_id : id
                },
                success : function(res){
                    $('#export-filter').html(res.xml_filters);
                    $('#export-template').html(res.xml_templates);
                }
            })
        }
    });

    $('#integration-crm-table').on('change', function(e){
        let id = $(this).val();

        if(id.length){
            $.ajax({
                type : 'GET',
                url : '/tablebuilder/table/fields/dropdown',
                data : {
                    id
                },
                success : function(res){
                    $('.xml-fields').html(res);
                }
            });

            $('.xml-section-mappings-holder').empty();

            $.ajax({
                type : 'GET',
                url : '/settings/xml_builder/sections',
                data : {
                    id
                },
                success : function(res){
                    $('.xml-section-mappings-holder').html(res);
                }
            });
        }
    });

    $(document).on('click', '#export-xml-data', function(e){
        let table_id = $('#export-table').val(),
            template = $('#export-template').val(),
            filter = $('#export-filter').val();

        if(table_id.length && template.length){
            let url = `/settings/xml_builder/view?table=${table_id}&template=${template}&filter=${filter}`;
            window.open(url, '_blank').focus();
        }
    });

    $(document).on('change', '.xml-type', function(e){
        let type = $(this).val(),
            $xml_mapping = $(this).parents('.xml-mapping'),
            $xml_value = $xml_mapping.find('.xml-value'),
            $xml_fields = $xml_mapping.find('.xml-fields'),
            $xml_sections = $xml_mapping.find('.xml-sections');

        if(type === 'XML tag with database field') {
            $xml_fields.removeClass('d-none');
            $xml_value.addClass('d-none');
            $xml_sections.addClass('d-none');
        }else if(type === 'XML tag with section'){
            $xml_value.addClass('d-none');
            $xml_fields.addClass('d-none');
            $xml_sections.removeClass('d-none');
        }else{
            $xml_value.removeClass('d-none');
            $xml_sections.addClass('d-none');
            $xml_fields.addClass('d-none');
        }
    });

    $('.duplicate-xml-builder').on('click', function(e){
        e.preventDefault();
        let id = $(this).attr('data-id');

        $.ajax({
            type : 'POST',
            url : '/settings/xml_builder/duplicate',
            data : {
                id
            },
            success : function(id){
                window.location = '/settings/xml_builder/edit/' + id;
            }
        });
    });

    $('.sortable-xml-mapping').sortable({
        cursor: 'grab',
        connectWith: ".sortable-xml-mapping",
        stop: function( ) {
            reCalculateXMLMappingIndex();
        }
    });

    function reCalculateXMLMappingIndex($container){
        let $mapping_indexes = $container.find('.mapping-index');

        $mapping_indexes.each(function(index, $index){
           $($index).text(index + 1);
        });
    }

    $('.delete-xml-builder').on('click', function(e){
        e.preventDefault();

        let id = $(this).attr('data-id');

        if(confirm('Are you sure you want to delete this XML template')){
            $.ajax({
                type : 'DELETE',
                url : '/settings/xml_builder',
                data : {
                    id
                },
                success : (res) => {
                    if(res){
                        $(this).parents('tr').remove();
                    }
                }
            });
        }
    });

    $(document).on('change', '.xml-fields', function(e){
        let id = $(this).val(),
            type = $(this).find(':selected').data('type'),
            related_id = $(this).find(':selected').data('related-table');

        if(type === 'relationship'){
            $.ajax({
                type : 'GET',
                url : '/tablebuilder/table/fields/dropdown',
                data : {
                    id: related_id
                },
                success : (res) => {
                    $(this).siblings('.related-xml-fields').html(res).removeClass('d-none');
                }
            });
        }else{
            $(this).siblings('.related-xml-fields').html('').addClass('d-none');
        }
    });

    $(document).on('change', '.xml-section-visibility', function(e){
        let $container = $(this).parents('.section-xml-mappings-container').find('.xml-section-mappings');
        if($(this).is(':checked')){
            $container.removeClass('d-none');
        }else{
            $container.addClass('d-none');
        }
    });
});